import { ISocialsConfig } from "@/config/socials.config";
import FacebookIcon from "@/icons/communication/facebook.svg";
import InstagramIcon from "@/icons/communication/instagram.svg";
import YoutubeIcon from "@/icons/communication/youtube.svg";

// Stage-specific social media configuration
const stageSocialsConfig: Partial<ISocialsConfig> = {
  socials: [
    {
      label: "Facebook",
      value: "facebook",
      icon: FacebookIcon,
      link: "https://facebook.com/avezor.stage",
    },
    {
      label: "Instagram",
      value: "instagram",
      icon: InstagramIcon,
      link: "https://instagram.com/avezor.stage",
    },
    {
      label: "Youtube",
      value: "youtube",
      icon: YoutubeIcon,
      link: "https://youtube.com/@avezor-stage",
    },
  ],
};

export default stageSocialsConfig;
